const UPLOAD_MARKER = '/image/upload/';

function hasTransformationSegment(segment) {
  if (!segment) return false;
  if (/^v\d+$/.test(segment)) return false;
  return /^(f_|q_|w_|c_|h_|dpr_|ar_)/.test(segment) || /^[^/]+,/.test(segment);
}

/** @param {'eco' | 'good' | 'best' | 'low' | 'auto'} quality */
function qualityToken(quality) {
  switch (quality) {
    case 'good':
      return 'q_auto:good';
    case 'best':
      return 'q_auto:best';
    case 'low':
      return 'q_auto:low';
    case 'auto':
      return 'q_auto';
    case 'eco':
    default:
      return 'q_auto:eco';
  }
}

/**
 * Inserta transformaciones Cloudinary (f_auto, calidad, ancho máximo) sin romper URLs ya optimizadas.
 * @param {string} url
 * @param {{ maxWidth?: number, quality?: 'eco' | 'good' | 'best' | 'low' | 'auto' }} opts
 */
export function optimizeCloudinaryUrl(url, opts = {}) {
  const maxWidth = opts.maxWidth ?? 1200;
  const quality = opts.quality ?? 'eco';
  if (!url || typeof url !== 'string') return url;
  const idx = url.indexOf(UPLOAD_MARKER);
  if (idx === -1) return url;
  const after = url.slice(idx + UPLOAD_MARKER.length);
  const firstSeg = after.split('/')[0];
  if (hasTransformationSegment(firstSeg)) return url;
  const transforms = `f_auto,${qualityToken(quality)},w_${maxWidth},c_limit`;
  return url.slice(0, idx + UPLOAD_MARKER.length) + transforms + '/' + after;
}

/**
 * Genera srcset para Cloudinary; si no es Cloudinary devuelve string vacío (usar solo :src).
 * @param {string} url URL base sin transformaciones de ancho fijo duplicadas
 * @param {number[]} widths
 * @param {{ quality?: 'eco' | 'good' | 'best' | 'low' | 'auto' }} [opts]
 */
export function cloudinarySrcset(url, widths = [640, 960, 1280, 1920], opts = {}) {
  if (!url || url.indexOf(UPLOAD_MARKER) === -1) return '';
  const quality = opts.quality ?? 'eco';
  return widths
    .map((w) => `${optimizeCloudinaryUrl(url, { maxWidth: w, quality })} ${w}w`)
    .join(', ');
}

export const CLOUDINARY_HERO_SIZES = '100vw';
